import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=5c53a2ca&"
import script from "./Lightbox.vue?vue&type=script&lang=js&"
export * from "./Lightbox.vue?vue&type=script&lang=js&"
import style0 from "./Lightbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports